export type Assessment = {
  level: Level;
  timeLevel: Level;
  pathLevel: Level;
  canceledText: string;
  penaltyText: string;
  score: number;
};

export type Level = 'beginner' | 'intermediate' | 'expert';

export type LevelTexts = {
  [key: string]: { beginner: string; intermediate: string; expert: string };
};
